exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-7d743cae] .template-column {\n  border: 2px dotted black;\n  padding: 5px;\n  margin: 15px;\n}\n[data-v-7d743cae] .template-column.selected-column {\n    border: 2px dashed gray;\n}\n", ""]);

